module.exports = __webpack_public_path__ + "static/media/newsletter-december-2022-8.2d83ba3b.jpg";